import { useContext } from 'react';
import { Campaign, Collab } from '@foodfluence/shared';
import { InfluencerDataContext } from 'contexts/InfluencerDataContext';
import { useCollabLocation } from './useCollabLocation';
import { resolveDueDateTimezone } from 'utils/timezoneUtils';

/**
 * The timezone the backend stamps and checks this collab's due date in (resolveDueDateTimezone):
 * store location → creator's stored zone → campaign's first location → UTC. The creator is the
 * loaded influencer, which on this app is the collab's own creator.
 */
export const useDueDateTimezone = (collab?: Collab | null, campaign?: Campaign | null): string => {
  const { influencerData } = useContext(InfluencerDataContext);
  const creatorTimezone = influencerData?.timezone;
  const { location: store } = useCollabLocation(collab?.selectedLocation ?? undefined);
  const { location: campaignLocation } = useCollabLocation(
    campaign?.foodfluenceLocations?.[0],
    !store?.timezone && !creatorTimezone
  );
  return resolveDueDateTimezone(store?.timezone, creatorTimezone, campaignLocation?.timezone);
};
